import { IDoorInstallationModel } from "../../entities-generated/models/project/door-installation-model";
import { IInstallationSiteModel } from "../../entities-generated/models/project/installation-site-model";
import { EventNotificationService, useEventNotification } from "../../framework/services/event-notification";

enum Events {
  DoorSelected = 'ShopApp.Checkout.DoorSelected',
  HandleSelected = 'ShopApp.Checkout.HandleSelected',
  ExcludeInstallation = 'ShopApp.Checkout.ExcludeInstallation',
}

export const fireDoorSelected = (door: IDoorInstallationModel, site: IInstallationSiteModel) => {
    EventNotificationService.dispatch(Events.DoorSelected, { door, site });
}
export function useDoorSelected(handler: (args: {door: IDoorInstallationModel, site: IInstallationSiteModel}) => void,
  deps: React.DependencyList, subscriberId: string) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEventNotification(handler, deps, Events.DoorSelected, subscriberId);
}

export const fireHandleSelected = (door: IDoorInstallationModel, site: IInstallationSiteModel) => {
    EventNotificationService.dispatch(Events.HandleSelected, { door, site });
}
export function useHandleSelected(handler: (args: {door: IDoorInstallationModel, site: IInstallationSiteModel}) => void,
  deps: React.DependencyList, subscriberId: string) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEventNotification(handler, deps, Events.HandleSelected, subscriberId);
}

export const fireExcludeInstallation = (door: IDoorInstallationModel, site: IInstallationSiteModel) => {
    EventNotificationService.dispatch(Events.ExcludeInstallation, { door, site });
}
export function useExcludeInstallation(handler: (args: {door: IDoorInstallationModel, site: IInstallationSiteModel}) => void,
  deps: React.DependencyList, subscriberId: string) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEventNotification(handler, deps, Events.ExcludeInstallation, subscriberId);
}